/* eslint-disable react/prop-types */
import React from 'react'
import SelectedItemWithForm from './SelectedItemWithForm'
import SelectedItemWithoutForm from './SelectedItemWithoutForm'

const SelectedItem: React.FC<SelectedItem> = props => {
    const { item, ...rest } = props
    if (!item) return null

    if ((item as ExportAnnotationRegistryWithoutForm).onExport) {
        return <SelectedItemWithoutForm {...rest} onExport={(item as ExportAnnotationRegistryWithoutForm).onExport} />
    }

    const Form = (item as ExportAnnotationRegistryWithForm).outputFormComponent
    if (Form) return <SelectedItemWithForm {...rest} Form={Form} />

    return null
}

export default SelectedItem
